export default {
  namespaced  : true,
  state : {
    isLoading : false,
  },
  mutations : {
    setIsLoading(state, payload){
      state.isLoading = payload;
    },

    resetStore(state){
      state.isLoading = false;
    }
  },
  actions : {
    updateGlobalLoading(context, payload){
      context.commit('setIsLoading', payload.value);
    },

    resetStore(context){
      context.commit('resetStore');
    }
  },
};
  